// extracted by mini-css-extract-plugin
module.exports = {"policyHomeOwnersSection":"PolicyDwellingInfoHO6_policyHomeOwnersSection__g2w1c","blank":"PolicyDwellingInfoHO6_blank__15tCY"};